export const GAMES = ['minecraft-java'] as const;

export type GameId = (typeof GAMES)[number];

/** Everything game-specific that infra, services and the UI share. */
export interface GameDefinition {
  readonly id: GameId;
  readonly displayName: string;
  /** For tight spots, before a version: "Minecraft 26.3". */
  readonly shortName: string;
  /** What players call the client they launch: "Minecraft Java" (`versionText`). */
  readonly clientName: string;
  /**
   * The container image, unpinned. A server runs its version's pinned image (`VERSION_RULES`);
   * this one only when the catalog can't place its version.
   */
  readonly image: string;
  /** Port players connect to. */
  readonly port: number;
  readonly protocol: 'tcp' | 'udp';
  /** Graviton instance type used unless the server overrides it. */
  readonly defaultInstanceType: string;
  /** Default size of the game data volume. */
  readonly dataVolumeGiB: number;
  /** The publisher's terms an owner agrees to when creating a server (the create page links them). */
  readonly eula: { readonly name: string; readonly url: string };
}

export const GAME_DEFINITIONS: Record<GameId, GameDefinition> = {
  'minecraft-java': {
    id: 'minecraft-java',
    displayName: 'Minecraft: Java Edition',
    shortName: 'Minecraft',
    clientName: 'Minecraft Java',
    image: 'docker.io/itzg/minecraft-server',
    port: 25565,
    protocol: 'tcp',
    defaultInstanceType: 't4g.medium',
    dataVolumeGiB: 10,
    eula: { name: 'Minecraft EULA', url: 'https://aka.ms/MinecraftEULA' },
  },
};

/** Which client to launch to play it: "Minecraft Java: Version 26.3" (the Discord bot, M14.7). */
export function versionText(game: GameId, version: string): string {
  return `${GAME_DEFINITIONS[game].clientName}: Version ${version}`;
}
